import React from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const QuillEditor = ({ value, onChange }) => {
  return (
    <ReactQuill
      theme="snow"
      value={value}
      placeholder="Write the Description here..."
      onChange={onChange}
      style={{
        height: "130px",
      }}
    />
  );
};

export default QuillEditor;
